export default __webpack_public_path__ + "static/media/reloj.4866c1ed.svg";